import { render, staticRenderFns } from "./DeleteDigistaffDialog.vue?vue&type=template&id=eff47b16"
import script from "./DeleteDigistaffDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDigistaffDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports